<template>
  <v-card
    class="my-3"    
    style="background-color: rgb(var(--v-theme-contained))"
    variant="elevated"
    elevation="2"
    width="100%"
    @click="$emit('navigate', node.id)"
  >
    <v-row>
      <!-- Fixed size column -->
      <v-col cols="auto">
        <GraphlyD3
          ref="graphly"
          :dark="darkTheme"
          :env-gravity="0"
          style="width: 130px; height: 130px"
        />
      </v-col>
      
      <!-- Growing column -->
      <v-col>
        <v-card style="height: 100%;">
          <v-card-title>{{ title }}</v-card-title>
          <span 
            v-for="([key, content], index) in Object.entries(node.payload)" 
            :key="index" 
            style="display: contents;"
          >
            <v-card-text v-if="Array.isArray(content)" style="padding-top: 0; padding-bottom: 0;">{{ key }}: {{ content.join(", ") || "undefined" }}</v-card-text>
            <span v-else-if="typeof content == 'object'" style="display: contents;">
              <v-card-text
                v-for="([key_inner, content_inner], index_inner) in Object.entries(content)" 
                :key="index_inner" 
                style="padding-top: 0; padding-bottom: 0;"
              >
                {{ key }} - {{ key_inner }}: {{ content_inner || "undefined" }}
              </v-card-text>            
            </span>
            <v-card-text v-else style="padding-top: 0; padding-bottom: 0;">{{ key }}: {{ content || "undefined" }}</v-card-text>            
          </span>
        </v-card>
      </v-col>
    </v-row>
    
    <!-- Bottom right chevron icon -->
    <v-btn icon class="bottom-right">
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </v-card>
</template>

<script setup lang="ts">
import { computed, onMounted, ref} from "vue";

import "@livereader/graphly-d3/style.css";
import GraphlyD3 from "@livereader/graphly-d3/component/vue3";
import { useGraphStore } from "../../../../store/graph";
import { useSymbolsStore } from "../../../../store/symbols";
import { ConceptDataobject, InstanceDataobject } from "@lr-notitia/notitia-operator/schemas";

const compProps = defineProps<{
	node: any;
}>();
defineEmits(["navigate"]);

const graphly = ref<any>(null);
const darkTheme = ref(false);
const graph = ref<{nodes:Array<any>, links: Array<any>}>({ nodes:[compProps.node], links: []})

onMounted(() => {
  graphly.value.simulation.render(graph.value, 0);
  graphly.value.simulation.moveTo({
		nodes: graph.value.nodes,
		padding: 10,
	});
})

const graphStore = useGraphStore();
const symbolsStore = useSymbolsStore();
const dataobject = computed(() => {
	if (false) return graphStore.concept.dataobject.byId(compProps.node.id);
	else return graphStore.instance.dataobject.byId(compProps.node.id);
});

const title = computed(() => {
	if (!dataobject.value) return "";
	if (false) {
		return symbolsStore.term({
			id: (dataobject.value as ConceptDataobject).refersTo,
			terminology: (dataobject.value as ConceptDataobject).terminology,
		});
	} else {
		let concept = graphStore.concept.dataobject.byId((dataobject.value as InstanceDataobject).concept);
		if (!concept) return "";
		return symbolsStore.term({ id: concept.refersTo, terminology: concept.terminology });
	}
});
</script>

<style scoped>
.bottom-right {
  position: absolute;
  bottom: 16px;
  right: 16px;
}
</style>